export const enum Features {
    CLIENT_HOME = "clientHome",
    MODEL_PORTFOLIOS = "modelPortfolios",
    REPORTS = "reports",
    HOLDINGS = "holdings",
    PERFORMANCE = "performance",
    CASHFLOW = "cashflow",
    REGISTRATION = "registration",
    REGISTRATION_KIWISAVER = "registrationKiwiSaver",
    DASHBOARD = "dashboard",
    TRANSACTIONS = "transactions",
    BUYSELL = "buySell",
    DOCUMENTS = "documents",
    DOCUMENT_LIBRARY = "documentLibrary",
    ACCOUNT_SETTINGS = "accountSettings",
    OLD_VIEW = "oldView",
    DATE_SELECTOR = "dateSelector",
    REGULAR_INVESTMENT_PLAN = "regularInvestmentPlan",
    NOTIFICATIONS = "notifications",
    ASSETPERFORMANCE = 'assetPerformance',
    SIGN_IN = "signIn",
    FOOTER = "footer",
    HEADER = 'header',
    PUBLIC_HEADER = 'publicHeader',
    GOOGLE_TAG_MANAGER = 'googleTagManager',
    INTERCOM = 'intercom',
    RAYGUN = 'raygun',
    TAX_DETAILS = 'taxDetails',
    ADDRESS_DETAILS = 'addressDetails',
    DEPOSITS = 'deposits',
    TRANSFERS = 'transfers',
    INVITATIONS = 'invitations',
    TERMDEPOSITS = 'termDeposits',
    INVESTORPROFILE = 'investorProfile',
    UNIVERSALLOGIN = 'universalLogin'
}

export enum BuySellFeatures {
    BUY_SELL = 'buySell',
    REGULAR_INVESTMENT_PLAN = 'regularInvestmentPlan',
    TERM_DEPOSITS = 'termDeposits',
    PENDING_ORDERS = 'pendingOrders'
}